const state = {
    discordToken: null
};

const mutations = {
    setToken(state, token) {
        state.discordToken = token;

        let item = JSON.stringify(token);
        localStorage.setItem('discord-token', item);
    },
    deleteToken(state) {
        state.discordToken = null;
        localStorage.removeItem('discord-token');
    }
};

const actions = {
    // INIT
    initialize(context) {
        let item = localStorage.getItem('discord-token');
        if (item) {
            context.state.discordToken = JSON.parse(item);
        }
    },
    // ACTIONS
    getProfile(context) {
        return new Promise((resolve, reject) => {
            let token = context.state.discordToken;
            if (!token) {
                reject();
            } else if (new Date().getTime() - 24 * 60 * 60 * 1000 > (token.created_at + token.expires_in)) {
                const data = new FormData();
                data.append('client_id', '793175355220557844');
                data.append('client_secret', '-TEHB717Y6gdqEj9ZMzLmBgnfYLgIqRK');
                data.append('grant_type', 'refresh_token');
                data.append('redirect_uri', 'http://jeux.stadiafr.com/login');
                data.append('scope', 'identify');
                data.append('refresh_token', token.refresh_token);

                fetch('https://discord.com/api/oauth2/token', {
                    method: "POST",
                    body: data
                })
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        reject(data.error);
                    } else {
                        let token = {
                            access_token: data.access_token,
                            refresh_token: data.refresh_token,
                            created_at: new Date().getTime(),
                            expires_in: 604800 * 1000
                        }

                        context.commit('setToken', token);
                        resolve();
                    }
                })
                .catch((error) => {
                    reject(error);
                });
            } else {
                resolve();
            }
        })
        .then(() => {
            return new Promise((resolve, reject) => {
                let token = context.state.discordToken;

                fetch('https://discord.com/api/users/@me', {
                    headers: { 'Authorization': 'Bearer ' + token.access_token }
                })
                .then((response) => {
                    if (response.ok) {
                        response.json().then(function(data) {
                            let profile = {
                                id: data.id,
                                username: data.username,
                                avatar: data.avatar
                            }
                            resolve(profile);
                        });
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    reject(error);
                });
            });
        })
        .catch((error) => {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        });
    },
    requestToken(context, discord_auth_code) {
        return new Promise((resolve, reject) => {
            const data = new FormData();
            data.append('client_id', '793175355220557844');
            data.append('client_secret', '-TEHB717Y6gdqEj9ZMzLmBgnfYLgIqRK');
            data.append('grant_type', 'authorization_code');
            data.append('redirect_uri', 'https://jeux.stadiafr.com/login');
            data.append('scope', 'identify');
            data.append('code', discord_auth_code);

            fetch('https://discord.com/api/oauth2/token', {
                method: "POST",
                body: data
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    reject(data.error);
                } else {
                    let token = {
                        access_token: data.access_token,
                        refresh_token: data.refresh_token,
                        created_at: new Date().getTime(),
                        expires_in: 604800 * 1000
                    }
                    console.error(token);
                    console.error('Token créé le ' + new Date(token.created_at) + ' et qui expire le ' + new Date(token.created_at + token.expires_in));
                    context.commit('setToken', token);
                    resolve();
                }
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
    deleteToken(context) {
        return new Promise((resolve) => {
            context.commit('deleteToken');
            resolve();
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};